import React from 'react'
import { withRouter } from 'react-router-dom'

import * as routes from '../constants/routes'

class LandingPage extends React.Component {
    componentDidMount() {
        this.props.history.push(routes.DASHBOARD)
    }

    render() {
        return (
            <div>
                <h1>Landing Page</h1>
            </div>
        )
    }
}

export default withRouter(LandingPage)



// WEBPACK FOOTER //
// ./src/components/Landing.js